// productsGrouped.js
// Products grouped into Global Crude, Fuels, Petrochemical Feedstocks, and Renewable Fuels

const products = {
  "CRUDE": { product: "CRUDE", label: "Crude Oil", description: "Raw petroleum extracted from fields, feedstock for refineries." },
  "CONDENSATE": { product: "CONDENSATE", label: "Field Condensate", description: "Light liquid hydrocarbons separated at the production site, often blended with crude." },
  "GASOLINE": { product: "GASOLINE", label: "Gasoline", description: "Motor fuel for spark-ignition engines; includes blends for retail use." },
  "KERO": { product: "KERO", label: "Kerosene", description: "Kerosene." },
  "GASOIL": { product: "GASOIL", label: "Gasoil", description: "Diesel fuel used in various sectors including transportation and industry." },
  "GASOIL-INLAND": { product: "GASOIL", label: "Inland", sector: "INLAND", description: "Gasoil used for on-road and off-road vehicles, heating, and industry." },
  "GASOIL-BUNKER": { product: "GASOIL", label: "Bunker", sector: "BUNKER", description: "Gasoil used as marine fuel in ships and vessels." },
  "FUEL OIL": { product: "FUEL OIL", label: "Fuel Oil", description: "Heavy residual product for power, industrial, or marine use." },
  "FUEL OIL-INLAND": { product: "FUEL OIL", label: "Inland", sector: "INLAND", description: "Fuel oil used for power generation and industrial applications." },
  "FUEL OIL-BUNKER": { product: "FUEL OIL", label: "Bunker", sector: "BUNKER", description: "Fuel oil used as marine fuel in ships and vessels." },
  "HSFO": { product: "HSFO", label: "High Sulfur Fuel Oil", description: "Fuel oil >0.5% sulfur; used in scrubber-equipped ships or industry." },
  "HSFO-INLAND": { product: "HSFO", label: "Inland", sector: "INLAND", description: "High sulfur fuel oil used for power generation and industrial applications." },
  "HSFO-BUNKER": { product: "HSFO", label: "Bunker", sector: "BUNKER", description: "High sulfur fuel oil used as marine fuel in ships and vessels." },
  "LSFO": { product: "LSFO", label: "Low Sulfur Fuel Oil", description: "Fuel oil ≤0.5% sulfur; compliant with IMO 2020 marine rules." },
  "LSFO-INLAND": { product: "LSFO", label: "Inland", sector: "INLAND", description: "Low sulfur fuel oil used for power generation and industrial applications." },
  "LSFO-BUNKER": { product: "LSFO", label: "Bunker", sector: "BUNKER", description: "Low sulfur fuel oil used as marine fuel in ships and vessels." },
  "JET": { product: "JET", label: "Jet Fuel", description: "Jet fuel for commercial and military aircraft." },
  "TOTAL PRODUCTS": { product: "TOTAL PRODUCTS", label: "Total Products", description: "Sum of all finished petroleum products produced or sold." },
  "OTHER": { product: "OTHER", label: "Other Products", description: "Miscellaneous refined products not included in main categories." },
  "NAPHTHA": { product: "NAPHTHA", label: "Naphtha", description: "Light liquid feedstock for petrochemicals and gasoline blending." },
  "NAPHTHA (MARKETED)": { product: "NAPHTHA (MARKETED)", label: "Naphtha (Marketed)", description: "Light liquid feedstock for petrochemicals sold to other industries." },
  "NAPHTHA (NON MARKETED)": { product: "NAPHTHA (NON MARKETED)", label: "Naphtha (Non-Marketed)", description: "Naphtha used internally within the refinery; not sold externally." },
  "ETHANE": { product: "ETHANE", label: "Ethane", description: "Ethane used as a petrochemical feedstock." },
  "ETHANE-FRACTIONATION": { product: "ETHANE", label: "Fractionation", sector: "FRACTIONATION", description: "Ethane used in fractionation processes." },
  "PENTANES PLUS": { product: "PENTANES PLUS", label: "Pentanes Plus", description: "C5+ hydrocarbons used as gasoline blendstock or petrochemical feedstock." },
  "PENTANES PLUS-FRACTIONATION": { product: "PENTANES PLUS", label: "Fractionation", sector: "FRACTIONATION", description: "Pentanes Plus used in fractionation processes." },
  "BUTANE": { product: "BUTANE", label: "Butane", description: "Butane used as a petrochemical feedstock or fuel." },
  "BUTANE-FRACTIONATION": { product: "BUTANE", label: "Fractionation", sector: "FRACTIONATION", description: "Butane used in fractionation processes." },
  "PROPANE": { product: "PROPANE", label: "Propane", description: "Propane used as a petrochemical feedstock or fuel." },
  "PROPANE-FRACTIONATION": { product: "PROPANE", label: "Fractionation", sector: "FRACTIONATION", description: "Propane used in fractionation processes." },
  "LPG": { product: "LPG", label: "Liquefied Petroleum Gas (LPG)", description: "Mixture of propane and butane used as fuel or feedstock." },
  "ETHANOL": { product: "ETHANOL", label: "Ethanol", description: "Ethanol used as a biofuel or industrial feedstock." },
  "ETHANOL_HYDROUS": { product: "ETHANOL_HYDROUS", label: "Ethanol Hydrous", description: "Hydrous ethanol used as a biofuel or industrial feedstock." },
  "BIODIESEL": { product: "BIODIESEL", label: "Gasoil Biodiesel", description: "Biodiesel blended with gasoil for transportation fuel." },
  "JETKERO-SAF": { product: "JETKERO-SAF", label: "Sustainable Aviation Fuel", description: "Renewable jet fuel blended with conventional jet fuel to reduce carbon emissions." },
};

const productGroupKeys = [
  {
    key: "CRUDE-GROUP", label: "Crude",
    children: [
      { key: "CRUDE" },
      { key: "CONDENSATE" }
    ]
  },
  {
    key: "FUELS", label: "Fuels",
    children: [
      { key: "GASOLINE" },
      { key: "KERO" },
      {
        key: "GASOIL",
        children: [
          { key: "GASOIL-INLAND" },
          { key: "GASOIL-BUNKER" }
        ]
      },
      {
        key: "FUEL OIL",
        children: [
          { key: "FUEL OIL-INLAND" },
          { key: "FUEL OIL-BUNKER" },
          {
            key: "HSFO",
            children: [
              { key: "HSFO-INLAND" },
              { key: "HSFO-BUNKER" }
            ]
          },
          {
            key: "LSFO",
            children: [
              { key: "LSFO-INLAND" },
              { key: "LSFO-BUNKER" }
            ]
          }
        ]
      },
      { key: "JET" },
      { key: "TOTAL PRODUCTS" },
      { key: "OTHER" }
    ]
  },
  {
    key: "PETROCHEMICAL_FEEDSTOCKS", label: "Petrochemical Feedstocks",
    children: [
      { key: "NAPHTHA" },
      { key: "NAPHTHA (MARKETED)" },
      { key: "NAPHTHA (NON MARKETED)" },
      { key: "ETHANE",        children: [{ key: "ETHANE-FRACTIONATION" }] },
      { key: "PENTANES PLUS", children: [{ key: "PENTANES PLUS-FRACTIONATION" }] },
      { key: "BUTANE",        children: [{ key: "BUTANE-FRACTIONATION" }] },
      { key: "PROPANE",       children: [{ key: "PROPANE-FRACTIONATION" }] },
      { key: "LPG" }
    ]
  },
  {
    key: "RENEWABLE_FUELS", label: "Renewable Fuels",
    children: [
      { key: "ETHANOL" },
      { key: "ETHANOL_HYDROUS" },
      { key: "BIODIESEL" },
      { key: "JETKERO-SAF" }
    ]
  }
];

export const getProductsTree = (groups = false) => {
  const _products = getProducts();
  const resolveItem = (item) => {
    const product = _products[item.key];
    if (item.children) {
      return { ...product, children: item.children.map(resolveItem) };
    }
    return product;
  };
  const productsByGroup = {};
  productGroupKeys.forEach(group => {
    if (groups && !groups.includes(group.key)) return;
    productsByGroup[group.key] = {
      label: group.label,
      key: group.key,
      children: group.children.map(resolveItem),
    };
  });
  return productsByGroup;
}

// Getter methods
export const getProducts = () => {
  Object.keys(products).forEach(key => {
    products[key] = { ...products[key], key };
  });
  return products;
};


export const getProductByKey = (key) => {
  return getProducts().find(product => product.key === key);
};

export const getProductByKeySector = (key, sector) => {
  const prodKey = `${key}-${sector}`;
  const _products = getProducts();
  return _products[prodKey];
};

export const getProductKeys = () => {
  return Object.keys(products);
};

export const getGroupNames = () => {
  return Object.keys(productsByGroup);
};
